// API 설정
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8010/api',
  TIMEOUT: 30000, // 30초
};

// CORS 설정 (개발 환경)
export const CORS_CONFIG = {
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
};

